import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from 'components/spinner';

import './style.css';

const getSizeInPx = (size) => {
  if (size === 'xl') return 8 * 18;
  if (size === 'l') return 8 * 5;
  if (size === 'm') return 8 * 4;
  return 8 * 3;
};

const Avatar = ({ name, src, size, loading, className, round }) => {
  const customClassName = classNames('avatar', className, `-${size}`, {
    '-round': round,
  });

  if (loading) return <Spinner />;

  const style = size
    ? {
        width: `${getSizeInPx(size)}px`,
        height: `${getSizeInPx(size)}px`,
      }
    : {};

  if (src) {
    return (
      <img
        style={style}
        className={customClassName}
        src={src}
        alt={`${name}`}
      />
    );
  }

  return (
    <div className={customClassName} style={style}>
      {name ? `${name[0]}` : null}
    </div>
  );
};

Avatar.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
  round: PropTypes.bool,
  src: PropTypes.string,
  name: PropTypes.string,
  loading: PropTypes.bool,
};

Avatar.defaultProps = {
  className: null,
  round: true,
  src: null,
  loading: false,
  name: '',
  size: 'm',
};

export default Avatar;
